import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import Swal from 'sweetalert2';
import Table2 from '../../core/pagination/datatable2'
// import { PlusCircle, Edit } from 'feather-icons-react/build/IconComponents';
import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import withReactContent from 'sweetalert2-react-content';
import {set_gateway_list, set_gateway_edit, set_page_refresh} from "../../core/redux/action";
import axios from 'axios';
import { all_routes } from "../../Router/all_routes";
// import { useNavigate } from "react-router-dom";

const SocialMediaVideoSchedulingAi = () => {
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    const route = all_routes;
    const pageRefresh = useSelector((state) => (state.pageRefresh?.paymentConfigs || 0));
    // const [dataStore, setDataStore] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        async function fetchData() {
            let result = await axios.get("getallscheduledpostsai/");
            const videoPosts = (result.data.posts || []).filter(
            (post) => post.postingType === "video"
            );

            dispatch(set_gateway_list(videoPosts));
        }
   
        fetchData()
        
      }, [pageRefresh])
      
      
    const dataSource = useSelector((state) => state.gateway_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'create');
    // const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}

  
    const columns = [
        {
        
            title: t?.[l]?.["title"] || "Title",
            dataIndex: "title"
        },

        {
            title: t?.[l]?.["ai_prompt"] || "Ai Prompt",
            dataIndex: "text",
        },
        {
            title: t?.[l]?.["plat_forms"] || "Plat forms",
            dataIndex: "platforms",
            render: (platform) => platform?.map(item => (t?.[l]?.[item?.split('-')[0]] || item?.split('-')[0])).join(', '),
    
        },
        {
            title: t?.[l]?.["schedule_time"] || "Schedule Time",
            dataIndex: "scheduleTime",
            render: (scheduleTime, record) => {
                const scheduleDate = record.scheduleDate;  // Assuming the date is in the `record`
                if (!scheduleTime) {
                    return "Immediate";  // If scheduleTime is not found, display only "Immediate"
                }
                return `${scheduleDate || "daily"} on ${scheduleTime}`;
            },
        },
        {
            title: t?.[l]?.["store_name"] || "Store Name",
            dataIndex: "storeName"
        },            
        {
            title: t?.[l]?.["error_message"] || "Error Message",
            dataIndex: "errorMessage",
        },
        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {/* {canUpdate && (
                         <Link  className="me-2 p-2" to={route.addsocialscheduling} onClick={() => {
                                        editSocialscheduling(record)
                                      }}>
                                        <Edit className="feather-edit" />
                                      </Link>

                
                        )} */}
                            {canDelete && (
                <Link className="me-2 p-2" to="#"
                onClick={(e) => {
                 e.preventDefault(); // Prevent the default anchor behavior
                 showConfirmationAlert(record);
               }}>
                <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
                   
                        )}
               
               
                    </div>
                </td>
            )
        }
    ]
    const MySwal = withReactContent(Swal);


    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                console.log('record._id',record);
                let result = await axios.post("removescheduledpostai/", {_id: record._id});
                console.log(result)
                dispatch(set_page_refresh("paymentConfigs"))
                MySwal.fire({
                title: t?.[l]?.["deleted!"] || "Deleted!",
                text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                className: "btn btn-success",
                confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }
        });
    };
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["social_media_ai"] || "Social Media Ai"}</h4>
                                <h6>{t?.[l]?.["manage_social_media_ai"] || "Manage Social Media"}</h6>
                            </div>
                        </div>
              
                        {canCreate ? (
                            <div className="page-btn">
                                           
                                <Link to={route.addsocialvideoschedulingai} className="btn btn-added" onClick={() => dispatch(set_gateway_edit({}))}>
                                <PlusCircle className="me-2 iconsize" />
                                {t?.[l]?.["add_scheduling"] || "Add Scheduling"}
                                </Link>
                            </div>
                          ) : null}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table2 columns={columns} dataSource={dataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
        </div>
    )
}

export default SocialMediaVideoSchedulingAi;
